import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { Logger } from '../../../../../../src/app/core/logger/logger.service';
import { FlightService } from '../../flight.service';

const log = new Logger('FlightDetailsComponent');
@Component({
    selector: 'app-flight-details',
    templateUrl: './flight-details.component.html',
    styleUrls: ['./flight-details.component.scss']
})
export class FlightDetailsComponent implements OnInit {
    @ViewChild('tabset') tabset: TabsetComponent;
    @Input() flight: any;
    tripType: any;
    isCollapsed = false;

    constructor(
        private flightService: FlightService,
        private route: ActivatedRoute,
    ) { }

    ngOnInit() {
        this.tripType = this.flightService.formFilled.tripType;
    }

    stops(flight: any) {
        return flight.FlightDetails.Details[0].length - 1;
    }

    goto(id) {
        this.tabset.tabs[id].active = true;
    }

}
